import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { PlatformIcon } from '@/components/brand-mentions/PlatformIcon'
import { ArrowUpRight, Star } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

interface TestimonialCardProps {
 name: string
 role: string
 avatar: string
 content: string
 rating?: number
 platform?: 'twitter' | 'uneed' | 'feedbask' | 'subclip'
 className?: string
}

export function TestimonialCard({ name, role, avatar, content, rating = 5, platform = 'uneed', className }: TestimonialCardProps) {
 const { i18n } = useTranslation()
 const fr = i18n.language?.startsWith('fr')
 const source = { twitter: 'X', uneed: 'Uneed', feedbask: 'Feedbask', subclip: 'Subclip' }[platform]
 return <article className={cn('fb-review-card', className)}>
  <header>
   <Avatar className="h-11 w-11">
    <AvatarImage src={avatar || undefined} alt={`${name}'s profile picture`} className="object-cover" />
    <AvatarFallback className="bg-primary/10 text-primary text-sm">{name.split(/[\s-]+/).slice(0, 2).map(part => part[0]).join('').toUpperCase()}</AvatarFallback>
   </Avatar>
   <div className="min-w-0"><strong>{name}</strong>{role && <small>{role}</small>}</div>
   <span className="fb-review-platform" aria-label={source}>
    {platform === 'twitter' ? <PlatformIcon platform="x" className="h-5 w-5" /> : platform === 'uneed' ? <img src="/images/uneed.svg" width="20" height="20" alt="" /> : <span className="text-primary font-semibold">{source[0]}</span>}
   </span>
  </header>
  {platform === 'uneed' && <div className="fb-review-stars" aria-label={`${rating}/5`}>{Array.from({ length: rating }, (_, index) => <Star key={index} size={13} fill="currentColor" aria-hidden="true" />)}</div>}
  <blockquote>{content}</blockquote>
  <footer><span>{platform === 'subclip' ? (fr ? 'Site du client' : 'Customer website') : (fr ? `Lire sur ${source}` : `Read on ${source}`)}</span><ArrowUpRight size={15} /></footer>
 </article>
}
